import { useDispatch } from 'react-redux';

import { X } from 'lucide-react';

import { featureFlagsReducer } from '../../store/reducers/featureFlags.reducer';
import { greyP4 } from '../../theme.ts';
import { FeatureFlag } from '../../types/featureFlags';

interface DeleteFeatureFlagModalProps {
  featureFlag: FeatureFlag;
  onClose: () => void;
}

export function DeleteFeatureFlagModal({ featureFlag, onClose }: DeleteFeatureFlagModalProps) {
  const dispatch = useDispatch();
  const { deleteFeatureFlag } = featureFlagsReducer.actions;

  const handleDelete = () => {
    dispatch(deleteFeatureFlag(featureFlag.id));
    onClose();
  };

  // Handle Esc key to close the modal
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onKeyDown={handleKeyDown}
    >
      <div
        className="rounded-lg p-6 w-[500px] max-w-[90vw] max-h-[90vh] overflow-y-auto"
        style={{ backgroundColor: greyP4 }}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-white">Delete Feature Flag</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X size={20} />
          </button>
        </div>

        <div className="mb-6">
          <p className="text-white mb-2">
            Are you sure you want to delete the feature flag <strong>"{featureFlag.name}"</strong>?
          </p>
          <p className="text-gray-400 text-sm">This action cannot be undone.</p>
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded bg-gray-700 hover:bg-gray-600">
            Cancel
          </button>
          <button type="button" onClick={handleDelete} className="px-4 py-2 rounded bg-red-700 hover:bg-red-600">
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
